module.exports = __webpack_public_path__ + "media/static/icons/icon-legend-star-d5acc351f5c48bbf6f2ddcc1ace1b811.svg";